import IconBase, { type IconProps } from '../IconBase';
const Svg24X24WarningBadgedFilled = (props: Omit<IconProps, 'children'>) => {
  return (
    <IconBase data-testid="warningBadgedFilled" viewBox="0 0 24 24" {...props} width="24" height="24">
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m0-3.975a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 6a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1"
          clipRule="evenodd"
        />
      </>
    </IconBase>
  );
};
export default Svg24X24WarningBadgedFilled;
